import { Injectable, signal, untracked } from '@angular/core';
import { Report, ReportType } from '../Domain/reports.model';
import { ReportService } from '@modules/reports/Services/reports.service';

@Injectable({ providedIn: 'root' })
export class ReportFacade {
  currentReport = signal<Report | null>(null);
  reportUrl = signal<string | null>(null);

  constructor(private service: ReportService) {}

  loadReport(report: Report) {
    untracked(() => this.currentReport.set(report));

    const backendType = report.type === ReportType.PANEL ? ReportType.PANEL_V2 : report.type;
    this.service.fetchReport(backendType, report.criteria).subscribe({
      next: (data: any) => {
        const url = data?.dashboardUrlsV2?.[0]?.url || null;
        untracked(() => this.reportUrl.set(url));
      },
      error: () => this.reportUrl.set(null),
    });
  }
}
